<template>

  <a target="_blank" :href="item.pdf">
    <pdf ref="pdf" :src="item.pdf" :resize="true" :text="false"></pdf>
    <pdf ref="pdf" :src="item.pdf" :resize="true" :text="false" :page="2"></pdf>
    <pdf ref="pdf" :src="item.pdf" :resize="true" :text="false" :page="3"></pdf>
    <pdf ref="pdf" :src="item.pdf" :resize="true" :text="false" :page="4"></pdf>
    <pdf ref="pdf" :src="item.pdf" :resize="true" :text="false" :page="5"></pdf>
    <pdf ref="pdf" :src="item.pdf" :resize="true" :text="false" :page="6"></pdf>
    <pdf ref="pdf" :src="item.pdf" :resize="true" :text="false" :page="7"></pdf>
    <pdf ref="pdf" :src="item.pdf" :resize="true" :text="false" :page="8"></pdf>
    <pdf ref="pdf" :src="item.pdf" :resize="true" :text="false" :page="9"></pdf>
    <pdf ref="pdf" :src="item.pdf" :resize="true" :text="false" :page="10"></pdf>
  </a>

</template>

<script>
  import pdf from 'pdfvuer'

  export default {
    name: 'AssociativeProject',
    components: {
      pdf
    },
    data() {
      return {
        item: {
          pdf: "https://www.asspm.fr/rubriques//projet_associatif.pdf"
        }
      }
    }
  }

</script>